import React from "react"
import { Helmet } from "react-helmet-async"
import { observer } from "mobx-react-lite"
import { Container, createStyles, Breadcrumbs, Anchor, Text } from "@mantine/core"
import { PageTitle } from "shared/ui/PageTitle"
import { CourseSearch } from "../../features/courses"
import { CoursesList } from "../../features/courses/CoursesList"
import { Link } from "react-router-dom"
import { PATHS } from "../../shared/lib/paths"

const items = [
  { title: "Главная", to: PATHS.ROOT },
  { title: "Все направления", to: PATHS.TRAINING.ROOT },
].map((item, index) => (
  <Anchor component={Link} to={item.to} key={index}>
    {item.title}
  </Anchor>
))

const useStyles = createStyles((theme) => ({
  container: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },
}))

export const CoursesListPage = observer(function CoursesListPage() {
    const { classes } = useStyles()
    const url = new URL(window.location.href)

    return (
      <>
        <Helmet>
          <title>Обучающие курсы</title>
          <meta property="og:title" content="Обучающие курсы от BodyCoach"/>

          <meta name="description"
                content="Обучающие курсы от BodyCoach"/>
          <meta property="og:description"
                content="Обучающие курсы от BodyCoach"/>

          <meta property="og:url" content={url.href}/>
          <link rel="canonical" href={url.href}/>
          <meta property="og:site_name" content={url.host}/>
          <meta name="robots" content="index, follow"/>

          <meta name="keywords"
                content="курсы боди коуч, боди коуч обучающие курсы, body coach обучение, учиться бодикоч"/>
        </Helmet>

        <Container size="xl">
          <Breadcrumbs>{items}</Breadcrumbs>
        </Container>

        <Container size="xl" className={classes.container}>
          <PageTitle title="Обучающие курсы"/>
          <CourseSearch variant="filled" radius="md" mb="xl" size="md"/>

          <CoursesList/>
        </Container>
      </>
    )
  },
)
